export default __webpack_public_path__ + "static/hovercards-304c8c103658320149621f9efb60fb35.png";